import React from "react";
import Image from "next/image";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import styles from "./Parallax.module.scss";

export default function Parallax(props) {
  const parallaxStyle = {
    height: "30vh", // 60% of the viewport height, adjust as necessary
  };
  let windowScrollTop = 0;
  const [transform, setTransform] = React.useState(
    "translate3d(0," + windowScrollTop + "px,0)"
  );
  React.useEffect(() => {
    if (window.innerWidth >= 768) {
      window.addEventListener("scroll", resetTransform);
    }
    return function cleanup() {
      if (window.innerWidth >= 768) {
        window.removeEventListener("scroll", resetTransform);
      }
    };
  });
  const resetTransform = () => {
    var windowScrollTop = window.pageYOffset / 3;
    setTransform("translate3d(0," + windowScrollTop + "px,0)");
  };
  const { filter, className, children, style, image, small } = props;
  const parallaxClasses = classNames(
    styles.parallax,
    className,
    {
      [styles[`${filter}Color`]]: Boolean(filter),
      [styles.small]: small,
    }
  );
  return (
    <div
      className={parallaxClasses}
      style={parallaxStyle}
      // style={{
      //   ...style,
      //   backgroundImage: "url(" + image + ")",
      //   transform: transform,
      // }}
    >
      <Image alt="Cover" src={image} layout="fill" objectFit="cover" />
      {children}
    </div>
  );
}

Parallax.propTypes = {
  className: PropTypes.string,
  filter: PropTypes.oneOf([
    "primary",
    "rose",
    "dark",
    "info",
    "success",
    "warning",
    "danger",
  ]),
  children: PropTypes.node,
  style: PropTypes.string,
  image: PropTypes.string,
  small: PropTypes.bool,
};
